<template>
  <div>
    <div v-if="loading" class="loader">
      <!-- <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner> -->
      <div class="col-12" style="margin-top: 14px;">
        <div class="row">
          <div class="col-2">
            <idx-skeleton height="238" radius="8"></idx-skeleton>
          </div>
          <div class="col-2">
            <idx-skeleton height="238" radius="8"></idx-skeleton>
          </div>
          <div class="col-2">
            <idx-skeleton height="238" radius="8"></idx-skeleton>
          </div>
          <div class="col-2">
            <idx-skeleton height="238" radius="8"></idx-skeleton>
          </div>
          <div class="col-2">
            <idx-skeleton height="238" radius="8"></idx-skeleton>
          </div>
          <div class="col-2">
            <idx-skeleton height="238" radius="8"></idx-skeleton>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="col-12" style="margin-top: 14px;">
        <div class="row main-card">
          <div
            :class="`col-md-${col}`"
            :style="`height: ${
              dataGraph.layout.h * multiplication
            }px; align-items: center;
    justify-content: center; padding: 5px;`"
          >
            <div
              class="format-card"
              :style="`
                height: ${dataGraph.layout.h * multiplication}px;`"
            >
              <div>
                <header>
                  <span class="title">{{
                    this.$t('reports.treatmentStatus.answers')
                  }}</span>
                </header>
                <div class="description">
                  <span>{{ summary.totalAnswers }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="`col-md-${col}`"
            :style="`height: ${
              dataGraph.layout.h * multiplication
            }px; align-items: center;
    justify-content: center; padding: 5px;`"
          >
            <div
              class="format-card"
              :style="`
                height: ${dataGraph.layout.h * multiplication}px;`"
            >
              <div>
                <header>
                  <span class="title">{{
                    this.$t('reports.treatmentStatus.answeredLabel')
                  }}</span>
                </header>
                <div class="description">
                  <span style="color: #4de594;">{{
                    calculateAvarage(summary.answered, summary.totalAnswers)
                  }}</span>
                  <span style="font-size: 24px;">{{ summary.answered }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="`col-md-${col}`"
            :style="`height: ${
              dataGraph.layout.h * multiplication
            }px; align-items: center;
    justify-content: center; padding: 5px;`"
          >
            <div
              class="format-card"
              :style="`
                height: ${dataGraph.layout.h * multiplication}px;`"
            >
              <div>
                <header>
                  <span class="title">{{
                    this.$t('reports.treatmentStatus.openedLabel')
                  }}</span>
                </header>
                <div class="description">
                  <span style="color: #dc3545;">{{
                    calculateAvarage(summary.opened, summary.totalAnswers)
                  }}</span>
                  <span style="font-size: 24px;">{{ summary.opened }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="`col-md-${col}`"
            :style="`height: ${
              dataGraph.layout.h * multiplication
            }px; align-items: center;
    justify-content: center; padding: 5px;`"
          >
            <div
              class="format-card"
              :style="`
                height: ${dataGraph.layout.h * multiplication}px;`"
            >
              <div>
                <header>
                  <span class="title">{{
                    this.$t('reports.treatmentStatus.staggeredLabel')
                  }}</span>
                </header>
                <div class="description">
                  <span style="color: #ffc107;">{{
                    calculateAvarage(summary.staggered, summary.totalAnswers)
                  }}</span>
                  <span style="font-size: 24px;">{{ summary.staggered }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="`col-md-${col}`"
            :style="`height: ${
              dataGraph.layout.h * multiplication
            }px; align-items: center;
    justify-content: center; padding: 5px;`"
          >
            <div
              class="format-card"
              :style="`
                height: ${dataGraph.layout.h * multiplication}px;`"
            >
              <div>
                <header>
                  <span class="title">{{
                    this.$t('reports.treatmentStatus.analysedLabel')
                  }}</span>
                </header>
                <div class="description">
                  <span style="color: #72bcd4;">{{
                    calculateAvarage(summary.analysis, summary.totalAnswers)
                  }}</span>
                  <span style="font-size: 24px;">{{ summary.analysis }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="`col-md-${col}`"
            :style="`height: ${
              dataGraph.layout.h * multiplication
            }px; align-items: center;
    justify-content: center; padding: 5px;`"
          >
            <div
              class="format-card"
              :style="`
                height: ${dataGraph.layout.h * multiplication}px;`"
            >
              <div>
                <header>
                  <span class="title">{{
                    this.$t('reports.treatmentStatus.others')
                  }}</span>
                </header>
                <div class="description">
                  <span style="color: #72bcd4;">{{
                    calculateAvarage(summary.other, summary.totalAnswers)
                  }}</span>
                  <span style="font-size: 24px;">{{ summary.other }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '../../../../../services/api';

export default {
  name: 'CardStatus',

  props: ['dataGraph'],

  components: {
    idxSkeleton,
  },

  data: () => ({
    loading: false,
    emptyState: false,
    userAuth: null,
    channel: null,
    status: null,
    summary: {
      email: {
        totalAnswers: 0,
        answered: 0,
        opened: 0,
        staggered: 0,
        analysis: 0,
        other: 0,
      },
    },
    col: 2,
    multiplication: 25,
  }),

  watch: {
    // 'dataGraph.layout.h': function watchmyActionId(height) {
    //   if (height <= 16) {
    //     this.col = 2;
    //     this.multiplication = 22;
    //   } else {
    //     this.col = 4;
    //     this.multiplication = 12;
    //   }
    // },
    // 'dataGraph.layout.w': function watchmyActionId(weight) {
    //   if (weight <= 5) {
    //     this.col = 4;
    //     this.multiplication = 12;
    //   } else {
    //     this.col = 2;
    //     this.multiplication = 22;
    //   }
    // },
  },

  methods: {
    async loadChart(data) {
      this.loading = true;
      this.emptyState = false;

      const response = await api.get('/reports/treatment-status-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: data.actionId ? data.actionId._id : null,
          ih1: data.ih1 && data.ih1.length > 0 ? data.ih1.map((item) => item._id): null,
          period: data.period,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          _id: this.dataGraph._id,
        },
      });

      this.summary.totalAnswers = response.data.summary.totalAnswers;
      this.summary.answered = response.data.summary.answered;
      this.summary.opened = response.data.summary.opened;
      this.summary.staggered = response.data.summary.staggered;
      this.summary.analysis = response.data.summary.analysis;
      this.summary.other = response.data.summary.other;

      this.loading = false;
    },

    calculateAvarage(dividend, divider) {
      if (!dividend || !divider) {
        return '0%';
      }

      return `${Number(((dividend / divider) * 100).toFixed(2))}%`;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    // if (this.dataGraph.layout.w <= 5) {
    //   this.col = 4;
    //   this.multiplication = 15;
    // } else {
    //   this.col = 2;
    //   this.multiplication = 25;
    // }

    this.col = 4;
    this.multiplication = 19;
  },

  async mounted() {
    this.loading = true;

    // if (this.dataGraph.layout.w <= 5) {
    //   this.col = 4;
    //   this.multiplication = 15;
    // } else {
    //   this.col = 2;
    //   this.multiplication = 25;
    // }

    this.col = 4;
    this.multiplication = 19;

    await this.loadChart(this.dataGraph);

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.format-card {
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
  box-shadow: 0px 2px 6px rgba(41, 70, 97, 0.2);
  border-radius: 4px;
}

.title {
  font-weight: 400;
  font-size: 22px;
}

.description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 32px;
  color: #5e5e5e;
}

.search-invites {
  display: flex;
  flex-direction: row;
  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detractor-review {
  display: flex;
  justify-content: center;
  align-items: center;

  background: red;
  color: white;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}

.pagination-area-status-invites >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.w500 {
  width: 150px;
}
.w150 {
  width: 150px;
}

.pagination-area-status-invites .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-status-invites a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/treatment-status/panels/cards-status.vue